// extracted by mini-css-extract-plugin
export default {"header":"Terms_header__M0TA9","body":"Terms_body__A+2fL","container":"Terms_container__NX4IL","sidebar":"Terms_sidebar__6s6iD","active":"Terms_active__bICSY"};